import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './Navigator.module.css';
import * as contentTypes from '../../Editor/contentTypes';

const MAX_NAVIGATOR_SLIDES = 25

const Navigator = ({ width, jumpToQuestion, currentContent, contentList, HandleChangeCurrentContent, currentContentData }) => {

    const texts = useSelector(state => state.translate.texts);
    const [lineStatus, setLineStatus] = useState({ isStart: true, isEnd: true })
    const [currentList, setCurrentList] = useState([])
    const [maxSlides, setMaxSlides] = useState(MAX_NAVIGATOR_SLIDES);

    useEffect(() => {
        if (width > 1250) {
            setMaxSlides(MAX_NAVIGATOR_SLIDES)
        }
        if (width <= 1250) {
            setMaxSlides(20)
        }
        if (width <= 900) {
            setMaxSlides(15)
        }
        if (width <= 600) {
            setMaxSlides(9)
        }
    }, [width])

    useEffect(() => {
        if (currentContent) {
            let start, end;
            if (currentContent?.index < maxSlides) {
                start = 0;
                end = contentList?.length > maxSlides ? maxSlides : contentList?.length;
            } else {
                start = Math.floor(currentContent?.index / maxSlides) * maxSlides;
                end = start + maxSlides > contentList?.length ? contentList?.length : start + maxSlides;
            }
            if (Math.floor((currentContent?.index + 1) / maxSlides) === Math.floor(contentList?.length / maxSlides) && (currentContent?.index + 1) % maxSlides > 0 && contentList?.length > currentContent?.index) {
                start = contentList?.length - maxSlides
                end = start + maxSlides > contentList?.length ? contentList?.length : start + maxSlides;
            }
            setCurrentList(contentList?.slice(start, end));
        }
    }, [currentContent, maxSlides])

    useEffect(() => {
        if (currentList && contentList) {
            let newLineStatus = {}
            if (currentList[0].id !== contentList[0].id) {
                newLineStatus = { ...newLineStatus, isStart: false }
            } else {
                newLineStatus = { ...newLineStatus, isStart: true }
            }
            if (currentList[currentList.length - 1].id !== contentList[contentList.length - 1].id) {
                newLineStatus = { ...newLineStatus, isEnd: false }
            } else {
                newLineStatus = { ...newLineStatus, isEnd: true }
            }
            setLineStatus(newLineStatus);
        }
        if (Math.floor((currentContent?.index + 1) / maxSlides) === Math.floor(contentList?.length / maxSlides) && (currentContent?.index + 1) % maxSlides > 0 && contentList?.length > maxSlides && contentList?.length > currentContent?.index) {
            move((Math.floor((currentContent?.index + 1) / maxSlides) * (maxSlides)) - (contentList?.length - maxSlides) + (currentContent.index % maxSlides) + 1)
        }
        else {
            move((currentContent?.index % maxSlides) + 1)
        }
    }, [currentList]);

    const next = () => {
        if ((currentContent?.index % maxSlides) + 1 < currentList.length &&  currentList.length - 1 > currentContent?.index) {
            HandleChangeCurrentContent(currentList[(currentContent?.index % maxSlides) + 1], currentContent?.index + 1);
        }
        else if (contentList.length > currentContent.index + 1) {
            let start;
            if (currentContent.index + 1 + maxSlides < contentList.length) {
                start = currentContent.index + 1;
            }
            else {
                start = contentList.length - maxSlides;
            }
            const end = contentList.length > start + maxSlides ? start + maxSlides : contentList.length;
            setCurrentList(contentList.slice(start, end));
            HandleChangeCurrentContent(contentList[start], currentContent.index + 1);
        }
    }

    const prev = () => {
        if ((currentContent?.index % maxSlides) !== 0) {
            HandleChangeCurrentContent(currentList[(currentContent?.index % maxSlides) - 1], currentContent.index - 1)
        }
        else if (currentContent?.index > 0) {
            const end = currentContent?.index;
            const start = end - maxSlides > 0 ? end - maxSlides : 0;
            setCurrentList(contentList.slice(start, end));
            HandleChangeCurrentContent(contentList[end - 1], end - 1);
        }
    }

    const nextQuestion = () => {
        let questionIndex = contentList.findIndex((x, i) => i > currentContent.index && x.type == contentTypes.quetion)
        if (questionIndex != -1)
            HandleChangeCurrentContent(contentList[questionIndex], questionIndex)
    }

    const prevQuestion = () => {
        let questionIndex = contentList.findLastIndex((x, i) => i < currentContent.index && x.type == contentTypes.quetion)
        if (questionIndex != -1)
            HandleChangeCurrentContent(contentList[questionIndex], questionIndex)
    }

    const move = (precents) => {
        let elem = document.getElementById("greenBar");
        if (elem && currentList) {
            let precentPart = 100 / (currentList?.length || 1);
            let newWidth = precentPart * (precents);
            elem.style.width = `${newWidth}%`;
        }
    }

    return (
        <div>
            {currentContent &&
                <div className={classes.FooterHover}>
                    <div className={classes.FooterContainer}>
                        {!jumpToQuestion ?
                            <div className={classes.Footer} >
                                <button className={classes.Prev} onClick={prev}></button>
                                <div className={`${classes.Lines} ${!lineStatus?.isStart && classes.NotStart} ${!lineStatus?.isEnd && classes.NotEnd}`}>
                                    <span id="greenBar" className={classes.greenBar}></span>
                                    {currentList.map((x, i) => {
                                        const index = contentList.findIndex(item => item.id === x.id);
                                        return <div key={i} className={`${classes.Line} ${currentContent.index === i ? classes.LineCurrrent : i < currentContent.index ? classes.FillLine : null}`}>
                                            {(index + 1) % 10 === 0 && `${index + 1}`}
                                        </div>
                                    })}
                                </div>
                                <button className={classes.Next} onClick={next}></button>
                            </div> :
                            <div className={classes.FooterQuestions}>
                                <button className={classes.Prev} onClick={prevQuestion}></button>
                                <div className={classes.AllQuestions}>{texts.allQuestions}</div>
                                <button className={classes.Next} onClick={nextQuestion}></button>

                            </div>}
                    </div>
                </div>
            }
        </div>

    );
}

export default Navigator;
